import { useEffect, useState } from 'react';
import {
  deleteSearchParam,
  getSearchParams,
  navigateReplace,
  setSearchParamTrue,
} from '@utils/url.utils';
import { Modal, navigatePush } from './Gallery.utils';

export const useGalleryNavigation = () => {
  const [searchParams, setSearchParams] = useState<URLSearchParams | undefined>();

  const showGalleryModal = searchParams?.get(Modal.gallery) === 'true';
  const showLightbox = searchParams?.get(Modal.lightbox) === 'true';

  useEffect(() => {
    const handlePopState = () => {
      setSearchParams(getSearchParams);
    };

    setSearchParams(getSearchParams);
    window.addEventListener('popstate', handlePopState);

    return () => window.removeEventListener('popstate', handlePopState);
  }, [setSearchParams]);

  const openModal = (modal: Modal) => {
    const url = setSearchParamTrue(modal);
    navigatePush(url, { modal });

    setSearchParams(url.searchParams);
  };

  const closeModal = (modal: Modal) => {
    const url = deleteSearchParam(modal);

    if (window.history.state) {
      window.history.back();
    } else {
      navigateReplace(url);
    }

    setSearchParams(url.searchParams);
  };

  return {
    closeModal,
    openModal,
    showGalleryModal,
    showLightbox,
  };
};
